import _ from 'lodash';

export default class mailEditor {
    constructor() {
        return {
            restrict: 'E',
            replace: true,
            template: '<div id="mail-editor" rm-langblocks></div>',
            controller: EmailEditorCtrl,
            controllerAs: 'editor'
        }
    }
};

class EmailEditorCtrl {
    constructor($scope, $element, $filter, $compile, $translate, ImageBank, Customization, Template, EditorEventHandler, SlugService, Rest, BlockService, CustomBlockParser, $sce, $timeout, $window) {
        this._scope = $scope;
        this._compile = $compile;
        this._translator = $filter('translate');
        this._element = $element;
        this._sce = $sce;
        this._timeout = $timeout;
        this._window = $window;

        this.rest = Rest.rest;
        this.imageBankRepo = ImageBank;
        this.customRepo = Customization;
        this.editorEventHandler = EditorEventHandler;
        this.templateRepo = Template;
        this.blockService = BlockService;
        this.customBlockParser = CustomBlockParser;
        this.updateImagesQueue = [];

        this.config = {
            padding: 20,
            thumbnailProxy: "campaign/template/thumbnail_proxy",
            thumbnailPlaceholder: "template-thumbnails",
            thumbnailClassNames: "col-md-4 col-xs-4",
            buttonsPlaceholder: "#mail-editor-button-placeholder"
        };

        this.settingsActivated = false;
        this.linkUnderlines = {value: false, changed: false};
        this.displayBlock = {value: false, changed: false};
        this.linkColors = {value: '', changed: false};
        this.preventWatcherInitialTriggers = {underlines: true, colors: true};
        this.preventWatcherInitialTriggers = {blockImages: true, colors: true};
        this.getCustomFields();

        $translate('MAILEDITOR:UTM_CONTENT').then((translation) => {
            CKEDITOR.on('dialogDefinition', (ev) => {
                let dialogName = ev.data.name, dialogDefinition = ev.data.definition;

                if (dialogName === 'image') {
                    setTimeout(() => {
                        const $contents = $(ev.data.definition.dialog.parts.contents.$);
                        const $inputUrl = $contents.find('.cke_dialog_image_url input');
                        const $altTextInput = $contents.find('.cke_dialog_page_contents').first().find('table:first > tbody > tr:nth-child(2) input');

                        $inputUrl.on('change', _.debounce(() => {
                            const url = $inputUrl.val();

                            if (url) {
                                $scope.$emit("spinner:start");
                                this.imageBankRepo.recognizeAltText(url).then(({ alt }) => {
                                    if (alt) {
                                        $altTextInput.val(alt);
                                    }

                                    $scope.$emit("spinner:stop");
                                })
                            }
                        }, 150))

                    }, 0)
                }

                if (dialogName === 'link') {
                    let url, info = dialogDefinition.getContents("info");
                    let utm_contentIs = false;
                    angular.forEach(info.elements, (element) => {
                        if (Object.values(element).indexOf('utm_content') > -1) {
                            utm_contentIs = true;
                        }
                    });
                    if (utm_contentIs) {
                        return;
                    }

                    let linkTypeSelect = info.get('linkType');
                    const initialSelectOnChange = linkTypeSelect.onChange;

                    linkTypeSelect.onChange = function (changes) {
                        const utmContentField = this.getDialog().getContentElement('info','utm_content');

                        changes.data.value === 'url'
                            ? utmContentField.getElement().show()
                            : utmContentField.getElement().hide();

                        return initialSelectOnChange.apply(this, changes);
                    };

                    info.elements.push({
                        type: 'text',
                        id: 'utm_content',
                        label: translation,
                        onShow: function () {
                            url = this.getDialog().getContentElement('info', 'url');

                            if (url.getValue()) {
                                var parceUrl = url.getValue().match(/^([^?]+)(\?utm_content=(.*?))?$/);
                                this.setValue(parceUrl[3]);
                                url.setValue(parceUrl[1]);
                            }
                        },
                        commit: function () {
                            url = this.getDialog().getContentElement('info', 'url');
                            if (this.getValue()) {
                                url.setValue(url.getValue() + '?utm_content=' + this.getValue());
                            }
                        },
                        validate: function () {
                            this.setValue(SlugService.slugify(this.getValue()));
                        }
                    });
                }
            });
        });

        this._scope.$on('template:updateHtml', (event, callback) => {
            return callback(this.getHtmlContent());
        });

        this._scope.$on('event:updateImage', (event, data) => {
            if (data.imageIndex || data.imageIndex === 0) {
                const appropriateImage = $(this.updateImagesQueue[data.imageIndex]);
                appropriateImage
                    .attr('src', data.newImage)
                    .attr('data-cke-saved-src', data.newImage);
            }
        });

        $("#mail-editor").on('click', 'a', () => {
            return false;
        });

        this._scope.$on('$stateChangeStart', () => {
            this.removeEditables();
        });

        this._scope.$on('mailEditor:prepareHtml', (event, callback) => {
            this.constructor.removeOverlays();
            callback(this.getHtmlContent());
        });

        this._scope.$on('template:editor:loaded', () => {
            this.editHtmlCode();
        });

        this._scope.$on('mailEditor:settings:applyLinkUnderlineSettings', (event, setting) => {
            $('.iguana a').each((index, item) => {
                $(item).css('text-decoration', setting ? '' : 'none');
            });
        });

        this._scope.$on('mailEditor:settings:applyImageBlockSettings', (event, toBlock) => {
            $('.iguana img').each((index, item) => {
                $(item).css('display', toBlock ? 'block' : '');
            });
        });

        this._scope.$on('mailEditor:settings:setLinkColor', (event, toColor) => {
            if (this.constructor.validHexColorCode(toColor)) {
                $('.iguana a').each((index, item) => {
                    if ($(item).children('span').length) {
                        if ($(item).children('span').text().trim().length) {
                            $(item).text($(item).children('span').text());
                        }

                        $(item).children('span').remove();
                    }

                    $(item).css('color', toColor);
                });
            }
        });

        this._scope.$on('mailEditor:blockOverlay:toggle', (event, show) => {
            return show ? this.showBlocks() : this.constructor.removeOverlays();
        });

        this._scope.$on('mailEditor:element:handleAdded', (event, elementAdded) => {
            this.constructor.removeDropZones();
            $('.childButton').remove();

            $('.iguana-duplicatable, .iguana-switch').each((index, item) => {
                $(item).unbind();
            });

            $(this._element).removeClass('block-glow');

            this.addCKEditorToClass(elementAdded, [
                'iguana-single-editable',
                'iguana-rich-editable'
            ]);

            this.makeCopyAndMoveable(this._element, [
                'iguana-duplicatable',
                'iguana-switch'
            ])
        });

        this._scope.$on('mailEditor:state:init', (event, data) => {
            this.getEmailTemplate(data.templateId);
        });

        this._scope.$on('mailEditor:htmlSource', (event, source) => {

            if (!source) {
                return;
            }
            this.updateHtmlContent(source, true);
        });

        this._scope.$on('mailEditor:htmlSource:template', (event, source) => {
            this.updateHtmlContent(source, false);
        });

        this._scope.$on('sogeti:background:updated', (event, backgroundImage) => {
            let sogetiLargeImg = $('[data-rule-block-name="Large image"] img');

            sogetiLargeImg.attr('src', backgroundImage.publicPath);
            sogetiLargeImg.attr('data-cke-saved-src', backgroundImage.publicPath);

            let ratio = sogetiLargeImg.width() / backgroundImage.width;
            let imgHeight = parseInt(backgroundImage.height * ratio);

            sogetiLargeImg.attr('height', imgHeight);

            this._scope.$emit('sogeti:largeImage:updated');
        });

        this.setStylesDefaults();
    }

    static getElements(iFrame, className) {
        return $(iFrame).find('.' + className)
    };

    getContent(iFrame) {
        angular.forEach(CKEDITOR.instances, (instance) => {
            instance.updateElement();
        });

        let parsedContent = this.constructor.removeElementsWithClassFromHTMLString(iFrame.html(), '.drop-zone');
        parsedContent = this.constructor.removeCKEDITORAttributesFromHTMLString(parsedContent);
        parsedContent = this.customBlockParser.parseToCode(parsedContent);

        return this.startHtml + parsedContent + this.endHtml;
    };

    redrawCopyable() {
        this.constructor.removeDropZones();

        $('.childButton').remove();

        $('.iguana-duplicatable, .iguana-switch').each((index, item) => {
            $(item).unbind();
        });

        this.makeCopyAndMoveable(this._element, [
            'iguana-duplicatable',
            'iguana-switch'
        ]);
    };

    static removeElementsWithClassFromHTMLString(string, className) {
        let wrapper = $("<div>").append($(string));
        wrapper.find(className).remove();

        return wrapper.html();
    };

    static removeCKEDITORAttributesFromHTMLString(string) {
        let jHtmlObject = $(string);
        let wrapper = $("<div>").append(jHtmlObject);

        wrapper.find("[contenteditable]")
            .removeAttr('contenteditable spellcheck aria-label title aria-describedby role tabindex')
            .removeClass('cke_editable cke_editable_inline cke_contents_ltr cke_show_borders');

        return wrapper.html();
    };

    addCKEditorToClass(iFrame, classNames) {
        angular.forEach(classNames, (className) => {
            angular.forEach(this.constructor.getElements(iFrame, className), (element) => {
                this._timeout(() => {
                    this.makeEditable(element);
                });
            })
        })
    };

    removeEditables() {
        angular.forEach(CKEDITOR.instances, (instance) => {
            instance.destroy();
        });
    };

    makeEditable(element) {
        if ($(element).hasClass('hidden')) {
            return;
        }

        element.setAttribute("contenteditable", true);
        CKEDITOR.disableAutoInline = true;
        CKEDITOR.dtd.$editable.span = 1;
        CKEDITOR.dtd.$editable.td = 1;

        let ckeditor = CKEDITOR.inline(element, {
            customConfig: '/config/ckeditor_config.js'
        });

        let resetHtml = () => {
            this._scope.$apply(() => {
                this._sce.trustAsHtml(ckeditor.getData());
            });
        };

        ckeditor.on('dataReady', resetHtml);
        ckeditor.on('blur', resetHtml);

        let validDrop = (event) => {
            return !(
                event.originalEvent.dataTransfer &&
                event.originalEvent.dataTransfer.types && event.originalEvent.dataTransfer.types[0] &&
                event.originalEvent.dataTransfer.types[0] == 'rule/block'
            );
        };

        $(element).on('dragover', (event) => {
            let follower = $('#drag-drop-follower');
            let left = event.originalEvent.pageX - (follower.width() / 2) - 20;
            let top = event.originalEvent.pageY - follower.height() - 70;

            if (validDrop(event)) {
                if (follower.is(":hidden")) {
                    $('#drag-drop-follower').show();
                }

                event.preventDefault();
            }

            follower.offset({left: left, top: top});
        });

        $(element).on('dragenter', (event) => {
            event.preventDefault();
        });

        $(element).on('dragend dragleave', (event) => {
            if (event.originalEvent.dataTransfer) {
                $('#drag-drop-follower').hide();
            }
        });

        $(element).on('drop', (event) => {
            $('#drag-drop-follower').fadeOut();
            this.editorEventHandler.handleDrop(event);
        });
    };

    addDropZone(element) {
        let dropZoneBefore = $('<drop-zone data-drop-zone="true"></drop-zone>');
        let dropZoneAfter = $('<drop-zone data-drop-zone="true"></drop-zone>');
        let prev = $(element).prev();

        this._compile(dropZoneAfter)(this._scope);
        dropZoneAfter.insertAfter(element);

        if (!prev.hasClass('drop-zone') && prev.data('drop-zone') != true) {
            this._compile(dropZoneBefore)(this._scope);
            dropZoneBefore.insertBefore(element);
        }
    };

    static removeDropZones() {
        $('.drop-zone').remove();
    };

    static removeEventualImageMapping(element) {
        if ($(element).find('img').length > 0) {
            $(element).find('img').removeAttr('usemap');
            $(element).find('map').remove();
            $(element).find('area').remove();
        }

        return $(element);
    };

    makeCopyAndMoveable(iFrame, classNames) {
        let parentButtons = $('#parentButtons');

        angular.forEach(classNames, (className) => {
            angular.forEach(this.constructor.getElements(iFrame, className), (element) => {
                let item = parentButtons.clone();
                $(item).removeAttr('id');

                this.addDropZone(element);

                $(item).addClass('childButton');

                $(item).find('.add').on('click', (event) => {
                    let newElement = $(element).clone();
                    newElement.find('rm-block-toolbar').remove();
                    newElement = this.constructor.removeEventualImageMapping(this._compile(newElement)(this._scope));
                    newElement.hide().insertAfter($(element)).slideDown("slow");

                    $(newElement).removeAttr('data-rule-show-segment data-rule-show-tag data-rule-prioritize-tag data-rule-prioritize-segment');
                    this._scope.$emit('element:added', newElement);

                    event.stopPropagation();
                });

                if ($(element).has('img').length) {
                    $(item).find('.edit').css('display', 'block');
                    $(item).find('.edit').on('click', (event) => {

                        const selectedNode = $(this._window.getSelection().focusNode);
                        const editableImage = selectedNode.find('img').first()[0]
                            || selectedNode.closest('table').find('img').first()[0]
                            || $(element).find('img').first()[0];

                        if (this.updateImagesQueue.indexOf(editableImage) === -1) this.updateImagesQueue.push(editableImage);

                        const imageIndex = this.updateImagesQueue.indexOf(editableImage);

                        let imageURL = $(editableImage).attr('src');
                        this._scope.$emit('event:upload.image.to.edit', {
                            imageURL,
                            imageIndex
                        });

                        event.stopPropagation();
                    });
                }

                $(item).find('.remove').on('click', (event) => {
                    $(element).css('display', 'block').slideUp("slow", () => {
                        if (findNext($(element), className) === false && findPrevious($(element), className) === false) {
                            this.addDropZone(element);
                        }

                        $(item).remove();
                        $(element).remove();

                        this.redrawCopyable();
                    });

                    event.stopPropagation();
                });

                let findNext = (parent, className) => {

                    if ($(parent).next().length < 1) {
                        return false;
                    }

                    let next = parent.next();

                    if ($(next).hasClass(className)) {
                        return next;
                    }

                    return findNext(next, className);
                };

                let findPrevious = (parent, className) => {

                    if ($(parent).prev().length < 1) {
                        return false;
                    }

                    let prev = parent.prev();

                    if ($(prev).hasClass(className)) {
                        return prev;
                    }

                    return findPrevious(prev, className)
                };

                $(item).find('.down').on('click', (event) => {
                    let next = findNext($(element), className);

                    if (next) {
                        $(element).insertAfter(next);
                        this.redrawCopyable();
                    }

                    event.stopPropagation();
                });

                $(item).find('.up').on('click', (event) => {
                    let prev = findPrevious($(element), className);

                    if (prev) {
                        $(element).insertBefore(prev);
                        this.redrawCopyable();
                    }

                    event.stopPropagation();
                });

                $(item).find('.settings').on('click', (event) => {
                    if ($(element).hasClass('iguana-switch')) {
                        $(item).find('.block-settings__switch').addClass('active');
                    } else {
                        $(item).find('.block-settings__switch').removeClass('active');
                    }
                    $(item).find('.block-settings__list').toggle();
                    event.stopPropagation();
                });

                $(item).find('.block-settings__switch-add').on('click', (event) => {
                    this.addSwitchCustomization(element);
                    $(item).find('.block-settings__list').toggle();
                });

                $(item).find('.block-settings__switch-remove').on('click', (event) => {
                    this.removeSwitchCustomization(element);
                    $(item).find('.block-settings__list').toggle();
                });

                $(this.config.buttonsPlaceholder).append(item);

                $('html').click(() => {
                    $(item).fadeOut();
                    $(element).removeClass('block-glow');
                    this.hideSwitchSettings();
                });

                $(element).on('click', (event) => {
                    event.stopPropagation();

                    this.hideSwitchSettings();

                    if ($(element).find('.block-overlay').length > 0) {
                        return;
                    }

                    this.selectedImage = $(event.originalEvent.target).is("img") ? event.originalEvent.target : null;

                    $(item).css('top', $(element).offset().top + 'px');
                    $(item).css('left', ($(element).offset().left - 50) + 'px');

                    $('.childButton').each((index, element) => {
                        if (!$(element).is(item)) {
                            $(element).fadeOut(200);
                        }
                    });

                    $(item).fadeIn();
                    this.showSwitchSettings(element);
                });

                $(element).on('mouseenter', () => {
                    $(item).css('top', $(element).offset().top + 'px');
                    $(item).css('left', ($(element).offset().left - 50) + 'px');
                });

                $(item).on('mouseenter', (event) => {
                    $(element).addClass('block-glow');
                    event.stopPropagation();
                });

                $(item).on('mouseleave', (event) => {
                    $(element).removeClass('block-glow');
                    event.stopPropagation();
                })
            })
        });
    }

    getCustomFields() {
        this.customRepo.allGroups().then((groups) => {
            groups = this.rest.stripRestangular(groups.data);
            this._scope.$emit('mailEditor:customizations:fetched', groups);
            let customData = [];

            customData.push({name: this._translator('GLOBAL:SUBSCRIBER')});
            customData.push({name: 'Email', value: '[Subscriber:email]', label: 'Email'});
            customData.push({
                name: this._translator('SETTING:INDEX:PHONE'),
                value: '[Subscriber:phone_number]',
                label: this._translator('SETTING:INDEX:PHONE')
            });
            customData.push({
                name: this._translator('GLOBAL:LANGUAGE'),
                value: '[Subscriber:language]',
                label: this._translator('GLOBAL:LANGUAGE')
            });

            angular.forEach(groups, (group) => {
                customData.push({name: group.name});

                angular.forEach(group.fields, (groupField) => {
                    let typeId = groupField.type;

                    if (typeId == 'text' || typeId == 'datetime' || typeId == 'date') {
                        customData.push({
                            name: groupField.name,
                            value: '[CustomField:' + group.name + '.' + groupField.name + ']',
                            label: groupField.name
                        });
                    }
                });
            });

            customData.push({name: this._translator('REMOTE_CONTENT:DESCRIPTION')});
            customData.push({
                name: this._translator('REMOTE_CONTENT:ONCE_TAG'),
                value: '[RemoteContentOnce:http://www..]',
                label: this._translator('REMOTE_CONTENT:ONCE_TAG')
            });
            customData.push({
                name: this._translator('REMOTE_CONTENT:TAG'),
                value: '[RemoteContent:http://www..]',
                label: this._translator('REMOTE_CONTENT:TAG')
            });

            customData.push({name: this._translator('GLOBAL:MISC')});
            customData.push({name: this._translator('GLOBAL:DATE'), value: '[Date:now]'});

            localStorage.setItem('customFieldData', JSON.stringify(customData));
        })
    };

    updateHtmlContent(src, parse) {
        if ((this.htmlContent && src === this.htmlSource) || !src) {
            return;
        }

        this.htmlSource = src;
        this.removeEditables();
        this.rest.one(src)
            .customGET('', {
                type: 'text/html'
            }, {
                'Content-Type': 'text/html',
                'accept': 'text/html'
            }).then((res) => {
            this._scope.$emit('mailEditor:content:loaded');
            this.htmlContent = res;
            this._element.empty();

            let startPoint = res.indexOf("<table");
            let endPoint = res.lastIndexOf("</body>");

            this.startHtml = res.slice(0, startPoint);
            this.endHtml = res.slice(endPoint);

            let templateTable = res.slice(startPoint, endPoint) + '</table>';

            if (parse) {
                templateTable = this.customBlockParser.parseToHtml(templateTable);
            }

            this._element.append($(templateTable));

            this._compile(this._element)(this._scope);

            this.addCKEditorToClass(this._element, [
                'iguana-single-editable',
                'iguana-rich-editable'
            ]);

            this.makeCopyAndMoveable(this._element, [
                'iguana-duplicatable',
                'iguana-switch'
            ]);
        })
    };

    showBlocks() {
        angular.forEach($('.iguana-duplicatable'), (block) => {
            if (!$(block).hasClass('hidden')) {
                $(block).attr('data-rule-block', true);

                angular.element(block).append(
                    '<div class="block-overlay"><content-customization></content-customization>'
                );
                this._compile(block)(this._scope)
            }
        });
    };

    static removeOverlays() {
        $('.block-overlay').remove();
    };

    getEmailTemplate(templateId) {
        if (this.htmlContent != null) {
            this.removeEditables();
        }

        this.blockService.clear();

        this.templateRepo.getHtmlContent(templateId).then((source) => {
            source = this.customBlockParser.parseToHtml(source);
            this._scope.$emit('mailEditor:template:fetched', source);
        });
    };

    getHtmlContent() {
        return this.getContent(this._element);
    };

    static validHexColorCode(code) {
        return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(code);
    };

    editHtmlCode() {
        if (!$(this._element).attr('contenteditable')) {
            $(this._element).attr("contenteditable", true);

            CKEDITOR.inline($(this._element)[0], {
                customConfig: '/config/ckeditor_config.js'
            });
        }
    };

    addSwitchCustomization(element) {
        $(element).removeClass('iguana-duplicatable');
        $(element).addClass('iguana-switch');

        let contentTag = $(element).find('td').first();
        let content = contentTag.html();

        let html = '<rm-block-switch data-value="@{tags}"><rm-block-switch-default>' + content + '</rm-block-switch-default></rm-block-switch>';
        let compiledElement = this._compile(html)(this._scope);

        this._timeout(() => {
            contentTag.empty();
            contentTag.append(compiledElement);
            this._scope.$emit('element:added', element);
        });
    }

    removeSwitchCustomization(element) {
        $(element).removeClass('iguana-switch');
        $(element).addClass('iguana-duplicatable');

        let contentTagSelector = $(element).find('rm-block-switch-default');
        let contentTag = contentTagSelector.length > 0 ? contentTagSelector.first() : $(element).find('rm-block-switch-case').first();
        let content = contentTag.html();

        $(element).find('td').first().empty();
        $(element).find('td').first().append(content);
        this._scope.$emit('element:added', element);
    }

    showSwitchSettings(element) {
        $(element).find('rm-block-switch').addClass('active');
    }

    hideSwitchSettings() {
        $('rm-block-switch').removeClass('active');
    }

    setStylesDefaults() {
        const head = $('head');

        head.append(`
            <link id="temp-default-styles" href="/css/defaults.css" rel="stylesheet">
        `);

        this._scope.$on('$destroy', () => {
            head.find('#temp-default-styles').remove();
        });
    }
}
